// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var down = "Summary-module--down--2d937";
export var emphasis = "Summary-module--emphasis--67607";
export var green = "#57d33b";
export var greenLink = "Summary-module--green-link--e0afe";
export var grey = "var(--tone-mid)";
export var isPromo = "Summary-module--isPromo--2d08c";
export var notchGap = "32px";
export var oldOdds = "Summary-module--oldOdds--9db45";
export var orange = "#f8662b";
export var pulseColor = "Summary-module--pulseColor--cc55c";
export var red = "#ff2741";
export var stake = "Summary-module--stake--3b35c";
export var up = "Summary-module--up--15ff6";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";